import type { SavedSearchFieldsFragment } from './__generated__/saved-searches.zeus';

const DEFAULT_MARKET_FALLBACK = 'phoenix';
const CANONICAL_MARKET_SLUG = /^[a-z]+(?:[-_][a-z]+)*$/;

// Mirrors the marketplace path conventions in `src/pages/homes/[market].tsx`:
//   single-zone   -> /homes/zid_<id>
//   market-only   -> /homes/<market>
//   multi-zone    -> /homes/<market or fallback>?zoneIds=...
export const pickPathname = (savedSearch: SavedSearchFieldsFragment): string => {
  const { zoneIds, market } = savedSearch.location;
  if (zoneIds.length === 1) {
    return `/homes/zid_${zoneIds[0]}`;
  }
  if (market && CANONICAL_MARKET_SLUG.test(market)) {
    return `/homes/${market}`;
  }
  return `/homes/${DEFAULT_MARKET_FALLBACK}`;
};

// A market-level saved search for the market already loaded on the page can be
// applied with an in-page refetch. Zone/polygon searches and cross-market
// switches need fresh SSR data (market shape, coordinates, zone resolution),
// so those callers must hard-navigate instead.
export const canApplySavedSearchInPlace = (
  savedSearch: SavedSearchFieldsFragment,
  marketIdentifier: string | null,
): boolean =>
  !!savedSearch.location.market &&
  savedSearch.location.market === marketIdentifier &&
  savedSearch.location.zoneIds.length === 0 &&
  savedSearch.location.vertices.length === 0;
